// import { createRouter, createWebHistory } from 'vue-router'
// import Dashboard from '../components/MainDashboard.vue'
// import Settings from '../components/MainSettings.vue'

// const routes = [
//   { path: '/', component: Dashboard },
//   { path: '/settings', component: Settings },
// ]

// const router = createRouter({
//   history: createWebHistory(),
//   routes,
// })

// export default router
import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../components/MainDashboard.vue'
import Products from '../views/ProductsView.vue'
import Suppliers from '../views/SuppliersVieew.vue'
import Customers from '../views/CustomerView.vue'
import Orders from '../views/OrdersView.vue'
import Stock from '../views/StockView.vue'
import LoginView from '../views/LoginView.vue'
import CategoryView from '@/views/CategoryView.vue'
import WareHousesView from '@/views/WareHousesView.vue'

import PurchaseOrders from '../views/PurchaseOrdersView.vue'
import SalesOrders from '../views/SalesOrdersView.vue'
import AboutUs from '@/components/AboutUs.vue'
import AiHistoryView from '../views/AiHistoryView.vue'
import ReportsView from '../views/ReportsView.vue'
import UsersView from '../views/UsersView.vue'

const routes = [
  { path: '/', component: Dashboard },
  { path: '/products', component: Products },
  { path: '/suppliers', component: Suppliers },
  { path: '/customers', component: Customers },
  { path: '/orders', component: Orders },
  { path: '/stock', component: Stock },
  { path: '/login', component: LoginView },
  { path: '/categories', component: CategoryView },
  { path: '/warehouses', component: WareHousesView },
  { path: '/purchase-orders', component: PurchaseOrders },
  { path: '/sales-orders', component: SalesOrders },
  { path: '/about-us', component: AboutUs },
  { path: '/reports', component: ReportsView },
  { path: '/users', component: UsersView },
  { path: '/ai-history', component: AiHistoryView }
]

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Global navigation guard for authentication
router.beforeEach((to, from, next) => {
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const token = localStorage.getItem('access_token');
  const userRole = localStorage.getItem('user_role');

  if (authRequired && !token) {
    return next('/login');
  }
  if (to.path === '/login' && token) {
    return next('/');
  }
  if (to.path === '/users' && userRole !== 'Admin') {
    return next('/');
  }
  next();
});

export default router




// import { createRouter, createWebHistory } from 'vue-router'

// // Import your views
// import DashboardView from '@/views/DashboardView.vue'
// import ProductsView from '@/views/ProductsView.vue'
// import SuppliersView from '@/views/SuppliersView.vue'
// import CustomersView from '@/views/CustomersView.vue'
// import PurchaseOrdersView from '@/views/PurchaseOrdersView.vue'
// import SalesOrdersView from '@/views/SalesOrdersView.vue'
// import StockView from '@/views/StockView.vue'
// import LoginView from '@/views/LoginView.vue'
// import RegisterView from '@/views/RegisterView.vue'

// const routes = [
//   { path: '/', name: 'Dashboard', component: DashboardView },
//   { path: '/products', name: 'Products', component: ProductsView },
//   { path: '/suppliers', name: 'Suppliers', component: SuppliersView },
//   { path: '/customers', name: 'Customers', component: CustomersView },
//   { path: '/purchase-orders', name: 'PurchaseOrders', component: PurchaseOrdersView },
//   { path: '/sales-orders', name: 'SalesOrders', component: SalesOrdersView },
//   { path: '/stock', name: 'Stock', component: StockView },
//   { path: '/login', name: 'Login', component: LoginView },
//   { path: '/register', name: 'Register', component: RegisterView }
// ]

// const router = createRouter({
//   history: createWebHistory(),
//   routes
// })

// export default router
